<template>
    <div class="top_rated">
        <div class="container">

            <div class="mb-3 mb-md-4 d-flex align-items-center">
                <h2 class="top_rated__header d-inline flex-grow-1">Trending rooms</h2>
                <div class="spinner-border spinner-border-sm" role="status" v-if="!homes[0].id">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>

            <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4">
                <div class="col" v-for="room in reducedHomeList" :key="room.id">
                    <room :room="room"></room>
                </div>
            </div>           
        </div>
    </div>
</template>

<style lang="css">
.top_rated {
    background-color: #ffffff;
    padding-top: 50px;
}

.top_rated .top_rated__header {

    font-weight: 600;
}

.top_rated .top_rated__body {
    overflow: auto;
}

@media (min-width: 768px) {
    .top_rated .top_rated__body {
        overflow: hidden;
    }
}

.top_rated .top_rated__body__primary {
    flex: 1;
    position: relative;
    margin-right: 16px;
}

@media (min-width: 768px) {
    .top_rated .top_rated__body__primary:last-of-type {
        margin-right: 0;
    }
}

.top_rated .top_rated__body__primary div {
    width: 100%;
    background-color: #eee;
    position: relative;
    min-width: 196px;
    height: 184px;
    border-radius: 10px;
}

@media (min-width: 768px) {
    .top_rated .top_rated__body__primary div {
        height: 250px;
        min-width: initial;
    }
}

@media (min-width: 1400px) {
    .top_rated .top_rated__body__primary div {
        height: 304px;
    }
}

.top_rated .top_rated__body__primary div h1,
.top_rated .top_rated__body__primary div .h1 {
    font-size: 18px;

    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    z-index: 2;
}

.top_rated .top_rated__body__primary div img {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    border-radius: 8px;

}

.top_rated .top_rated__body__primary .location {
    padding: 3px 10px;
    background-color: #ffffff;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    position: absolute;
    bottom: 10%;
    left: 20px;
    border-radius: 5px;
    z-index: 999;
}

.top_rated .top_rated__body__secondary {
    display: inline-grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 10px;
    margin-left: 15px;
    text-align: center;
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__1 {
    display: inline-grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 10px;
}

@media (max-width: 575.98px) {
    .top_rated .top_rated__body__secondary .top_rated__body__secondary__1 {
        grid-template-columns: 1fr;
        margin-bottom: 10px;
    }
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__1 div {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    border: 1px solid #eee;
    justify-content: center;
    width: 335px;
    background-color: #eee;
    justify-self: center;
    height: 160px;
    object-fit: cover;
    position: relative;
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__1 div h1,
.top_rated .top_rated__body__secondary .top_rated__body__secondary__1 div .h1 {
    font-size: 18px;

    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    z-index: 2;
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__1 div img {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
}

@media (max-width: 575.98px) {
    .top_rated .top_rated__body__secondary .top_rated__body__secondary__1 div {
        width: 95%;
        height: 240px;
        border-radius: 10px;
    }
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__1 div:nth-child(2) {
    border-top-right-radius: 5px;
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__2 {
    grid-template-columns: 1fr 1fr 1fr;
    display: inline-grid;
    grid-column-gap: 10px;
}

@media (max-width: 575.98px) {
    .top_rated .top_rated__body__secondary .top_rated__body__secondary__2 {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        grid-row-gap: 10px;
    }
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__2 div {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    border: 1px solid #eee;
    justify-content: center;
    background-color: #eee;
    width: 96%;
    justify-self: center;
    position: relative;
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__2 div h1,
.top_rated .top_rated__body__secondary .top_rated__body__secondary__2 div .h1 {
    font-size: 18px;

    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    z-index: 2;
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__2 div img {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 1;
}

@media (max-width: 575.98px) {
    .top_rated .top_rated__body__secondary .top_rated__body__secondary__2 div {
        width: 95%;
        height: 240px;
        border-radius: 10px;
    }
}

.top_rated .top_rated__body__secondary .top_rated__body__secondary__2 div:nth-child(3) {
    border-bottom-right-radius: 5px;
}

@media (max-width: 575.98px) {
    .top_rated .top_rated__body__secondary {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        margin-left: 0px;
    }
}

.top_rated__see-all {
    min-width: 196px;
    height: 184px;
    border-radius: 10px;
    background: #f4c0d4;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.top_rated__see-all .icons-container {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.top_rated__see-all__link {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10%;
    white-space: nowrap;
    background: #fff;
    color: #e81865;
    border-radius: 4px;
}

.top_rated__see-all .locations-icon {
    position: absolute;
    top: -35px;
    margin-left: -5px;
}
</style>

<script>
import config from '@/utilities/config';
import http from '@/utilities/http';
import Room from '@/components/shared/room.vue';

export default {
    name: 'top-rated-homes',
    components: { Room },
    data: function () {
        return {
            homes: [{ images: [''] }, { images: [''] }, { images: [''] }, { images: [''] }],
        }
    },
    mounted() {
        try {
            http.get(config.HomePageTopHomesUrl)
                .then((response) => {
                    this.homes = response.result.topHomes;
                })
                .catch(function (error) {
                    console.error(error);
                });
        } catch (e) {
            console.error(error);

        }
    },
    computed: {
        reducedHomeList() {
            var newRooms = [...this.homes];
            newRooms.splice(4);
            return newRooms;
        }
    }
}
</script>